import React from 'react'
import { useCurrentUser } from 'contrastBase/state'
import { LocalizationProvider } from '@contrast-security-inc/design-system-foundations'

export function wrapWithSkeletorLocalizationProvider(WrappedComponent) {
  return function SkeletorLocalizationProvider(props) {
    const { currentUser } = useCurrentUser()

    const { locale } = currentUser || { locale: 'en' }

    return (
      <LocalizationProvider locale={locale as 'en' | 'es' | 'ja'}>
        <WrappedComponent {...props} />
      </LocalizationProvider>
    )
  }
}
